<template>
    <div>
        <v-tabs class="history-tab" v-model="tabData" fixed-tabs>
            <v-tab v-for="n in buttons" :key="n.name" ripple @click.prevent="$router.push({name: n.route})">
                <v-icon size="12px" class="transaction-icon">{{n.icon}}</v-icon>
                &nbsp;
                {{ $t(n.name) }}
            </v-tab>
        </v-tabs>
    </div>
</template>

<script>
export default {
    name: "HistoryTab",
    props: ["currentTab"],
    data() {
        return {
            tab: 0,
            buttons : [
                {
                    'name': 'history.deposit_record',
                    'route': 'History / Deposit',
                    'icon': 'fas fa-wallet'
                },
                {
                    'name': 'history.withdraw_record',
                    'route': 'History / Withdraw',
                    'icon': 'fas fa-money-bill-wave'
                },
                {
                    'name': 'history.transfer_record',
                    'route': 'History / Transfer',
                    'icon': 'fas fa-random'
                }
            ]
        }
    },
    computed: {
        tabData: function() {

            switch ( this.currentTab ) {

                case 'deposit':
                    this.tab = 0;
                    break;

                case 'withdraw':
                    this.tab = 1;
                    break

                case 'transfer':
                    this.tab = 2;
                    break
            }

            return this.tab;
        }
    },
}
</script>

<style>
.history-tab .v-tabs__bar {
    background-color: rgba(0,0,0,0.54);
}
</style>